var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * hbox
 */
import Text from '../../shapes/Text';
import VNode from '../vnode';
import { measureText } from '../../utils/measureText';
var VText = /** @class */ (function (_super) {
    __extends(VText, _super);
    function VText(props) {
        var _this = _super.call(this, props) || this;
        _this.type = 'text';
        _this._relayouted = false;
        _this.defaultProps = {
            value: '',
        };
        _this.props = __assign(__assign({}, _this.defaultProps), props);
        return _this;
    }
    VText.prototype.render = function () {
        var color = this.getClosestNodeProps('color');
        var parent = this.parentNode;
        var _a = this.bbox, left = _a.x, top = _a.y, width = _a.width, height = _a.height;
        var x = left;
        var y = top;
        var textAlign = 'left';
        var ellipsis = parent.props.ellipsis !== undefined;
        if (ellipsis) {
            if (parent.type === 'hbox') {
                textAlign = this.getTextAlign(parent.props.pack);
                x = this.getTextPosition(left, width + left, parent.props.pack);
            }
            else if (parent.type === 'hbox') {
                textAlign = this.getTextAlign(parent.props.align);
                x = this.getTextPosition(left, width + left, parent.props.align);
            }
        }
        return new Text({
            text: this.props.value,
            x: x,
            y: y + height / 2,
            textAlign: textAlign,
            textBaseline: 'middle',
            fontSize: this.getFontSize(),
            fontFamily: this.getFontFamily(),
            fontWeight: this.getFontWeight(),
            lineHeight: this.getExtendAttr('lineHeight'),
            fill: color,
            truncate: ellipsis && this.getTruncate(),
        });
    };
    VText.prototype.getTextAlign = function (align) {
        if (align === 'start') {
            return 'left';
        }
        if (align === 'end') {
            return 'right';
        }
        if (align === 'center') {
            return 'center';
        }
        return 'left';
    };
    VText.prototype.getTextPosition = function (left, right, align) {
        if (align === 'start') {
            return left;
        }
        if (align === 'end') {
            return right;
        }
        if (align === 'center') {
            return (left + right) / 2;
        }
        return left;
    };
    VText.prototype.getFontWeight = function () {
        return this.getExtendAttr('fontWeight') || 'normal';
    };
    VText.prototype.getFontSize = function () {
        return this.getExtendAttr('fontSize') || 12;
    };
    VText.prototype.getFontFamily = function () {
        return this.getExtendAttr('fontFamily') || 'sans-serif';
    };
    VText.prototype.computeSize = function () {
        if (this._relayouted) {
            return;
        }
        var _a = measureText(this.props.value, {
            fontSize: this.getFontSize(),
            fontWeight: this.getFontWeight(),
            fontFamily: this.getFontFamily(),
        }), width = _a.width, height = _a.height;
        this.minSize = [width, height];
    };
    VText.prototype.getTruncate = function () {
        var fontSize = this.getFontSize();
        var lineHeight = this.getExtendAttr('lineHeight') || fontSize;
        var parent = this.parentNode;
        var parentBBox = parent.getContentBox();
        // fix float error
        var outerWidth = parentBBox.width + 1;
        var outerHeight = lineHeight * (this.parentNode.props.lineClamp || 1);
        var ellipsis = this.parentNode.props.ellipsis;
        return {
            outerWidth: outerWidth,
            outerHeight: outerHeight,
            ellipsis: ellipsis,
        };
    };
    VText.prototype.layout = function () {
        if (this.ownerDocument.hasRelayouted()) {
            return;
        }
        if (this.parentNode.props.ellipsis !== undefined) {
            var textBBox = new Text({
                text: this.props.value,
                x: 0,
                y: 0,
                fontSize: this.getFontSize(),
                fontFamily: this.getFontFamily(),
                fontWeight: this.getFontWeight(),
                lineHeight: this.getExtendAttr('lineHeight'),
                fill: '#000000',
                truncate: this.getTruncate(),
            }).getBBox();
            this.minSize = [textBBox.width, textBBox.height];
            this._relayouted = true;
            this.ownerDocument.needRelayout();
        }
    };
    return VText;
}(VNode));
export default VText;
